import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { setSSROrigin } from "ssr-hook";

import App from "./App";
import { handleError } from "./services/api";

const rootElement = document.getElementById("root") as HTMLElement;

if (process.env.NODE_ENV === "development") {
    setSSROrigin("http://localhost:1111"); // development server
    createRoot(rootElement).render(<App />);
} else {
    hydrateRoot(rootElement, <App />, {
        onCaughtError: handleError,
        onUncaughtError: handleError,
        onRecoverableError: handleError,
    });
}
